"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _mobxReact = require("mobx-react");

var _AppStore = _interopRequireDefault(require("../Store/AppStore"));

var _patientPortalApiRequests = require("patient-portal-api-requests");

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 550,
      padding: theme.spacing(2)
    },
    gridCardContainer: {
      padding: theme.spacing(1, 3)
    },
    gridCardText: {
      flexGrow: 1
    },
    gridCardButton: {
      margin: "auto"
    },
    submitButton: {
      margin: theme.spacing(2, 0)
    },
    errorBackground: {
      backgroundColor: theme.palette.error.main
    },
    errorText: {
      color: theme.palette.error.contrastText
    },
    progressDialog: {
      padding: theme.spacing(3, 0)
    }
  };
});

var SummaryPage = function SummaryPage() {
  var classes = useStyles();
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      processing = _useState2[0],
      setProcessing = _useState2[1];

  if (!_AppStore.default.selectedAccount || !_AppStore.default.paymentAmount) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/accountSelect"
    });
  }

  if (!_AppStore.default.selectedPaymentMethod) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/paymentMethod"
    });
  }

  var accountPayment = function accountPayment() {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      raised: true,
      variant: "outlined"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      wrap: "nowrap",
      className: classes.gridCardContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.gridCardText
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6",
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("b", null, "Account Payment")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      align: "left",
      gutterBottom: true
    }, _AppStore.default.selectedAccount.displayName), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      align: "left",
      color: "textSecondary"
    }, "$", Number(_AppStore.default.paymentAmount).toFixed(2))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.gridCardButton
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "text",
      color: "primary",
      component: _reactRouterDom.Link,
      to: "/"
    }, /*#__PURE__*/_react.default.createElement("b", null, "EDIT"))))));
  };

  var paymentMethod = function paymentMethod() {
    var pathForEdit = _AppStore.default.selectedPaymentMethod.token ? "/cardEntry" : "/paymentMethod";

    var handleClick = function handleClick() {
      if (_AppStore.default.selectedPaymentMethod.token) {
        _AppStore.default.reloadTSEPScripts();
      }
    };

    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      raised: true,
      variant: "outlined"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      wrap: "nowrap",
      className: classes.gridCardContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.gridCardText
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6",
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("b", null, "Payment Method")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      align: "left",
      gutterBottom: true
    }, _AppStore.default.selectedPaymentMethod.displayName), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      align: "left",
      color: "textSecondary"
    }, "Expires ", _AppStore.default.selectedPaymentMethod.expiration)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.gridCardButton
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "text",
      color: "primary",
      component: _reactRouterDom.Link,
      to: pathForEdit,
      onClick: handleClick
    }, /*#__PURE__*/_react.default.createElement("b", null, "EDIT"))))));
  };

  var cardholderInformation = function cardholderInformation() {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      raised: true,
      variant: "outlined"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      wrap: "nowrap",
      className: classes.gridCardContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.gridCardText
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6",
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("b", null, "Cardholder Information")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      align: "left",
      gutterBottom: true
    }, _AppStore.default.selectedPaymentMethod.accountName), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      align: "left",
      color: "textSecondary"
    }, _AppStore.default.selectedPaymentMethod.addressLine1 + ", " + _AppStore.default.selectedPaymentMethod.zip)), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
      xsUp: Boolean(_AppStore.default.selectedPaymentMethod.walletId)
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.gridCardButton
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "text",
      color: "primary",
      component: _reactRouterDom.Link,
      to: "/cardholder"
    }, /*#__PURE__*/_react.default.createElement("b", null, "EDIT")))))));
  };

  var errorDisplay = function errorDisplay() {
    if (!_AppStore.default.error) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      raised: true,
      variant: "outlined",
      className: classes.errorBackground
    }, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
      avatar: /*#__PURE__*/_react.default.createElement(_Error.default, {
        fontSize: "large",
        className: classes.errorText
      }),
      title: /*#__PURE__*/_react.default.createElement("b", null, "Error: ", _AppStore.default.error),
      titleTypographyProps: {
        className: classes.errorText,
        align: "left",
        variant: "body1"
      },
      subheader: "Please correct the information or select a different payment method",
      subheaderTypographyProps: {
        className: classes.errorText,
        align: "left",
        variant: "body2"
      }
    })));
  };

  var submitPayment = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setProcessing(true);
              _context.prev = 1;
              _context.next = 4;
              return (0, _patientPortalApiRequests.postPayment)(_AppStore.default.postPaymentData);

            case 4:
              result = _context.sent;
              setProcessing(false);

              _AppStore.default.setReceiptInfo(result);

              history.push("/receipt");
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

              if (_context.t0.response.data.reason) {
                _AppStore.default.setError(_context.t0.response.data.reason);
              }

              setProcessing(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function submitPayment() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    className: classes.root
  }, errorDisplay(), accountPayment(), paymentMethod(), cardholderInformation(), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    className: classes.submitButton,
    fullWidth: true,
    onClick: submitPayment
  }, "Submit Payment")), /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: processing,
    fullWidth: true,
    maxWidth: "sm"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.progressDialog
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    size: 80
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.progressDialog
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, "Processing Payment...")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, "Don't leave just yet!"))))));
};

var _default = (0, _mobxReact.observer)(SummaryPage);

exports.default = _default;